export const PartnerProfileFormConfig = {
  companyName: {
    label: "Company Name",
    perKey: "CompanyName",
    rules: { required: "Company Name is Required!" }
  },
  legalBusinessName: {
    label: "Legal Business Name",
    perKey: "LegalBusinessName"
  },
  website: {
    label: "Website",
    perKey: "Website"
  },
  industrySector: {
    label: "Industry Sector",
    perKey: "IndustrySector"
  },
  dunsNumber: {
    label: "Duns Number",
    perKey: "DunsNumber"
  },
  taxId: {
    label: "Tax Id",
    perKey: "TAXId",
    rules: { required: "Tax Id is Required!" }

  },
  clientTypeId: {
    label: "Partner Category",
    perKey: "SelectPartnerCategory",
    rules: { required: "Partner Category is Required!" }
  },
  mainContactNumber: {
    label: "Main Contact Number",
    perKey: "MainContactNumber",
    rules: { required: "Main Contact Number is Required!" }
  },
  logo: {
    label: "Logo",
    perKey: "Logo",
    defaultValue: null,
    readKey: "partnerLogoPath"
  },
  mailingAddress1: {
    label: "Address1",
    perKey: "MailingAddress1",
    rules: { required: "Mailing Address is Required!" }
  },
  mailingAddress2: {
    label: "Address2",
    perKey: "MailingAddress2"
  },
  mailingCity: {
    label: "City",
    perKey: "MailingCity",
    rules: { required: "City is Required!" }
  },
  mailingState: {
    label: "State",
    perKey: "MailingState",
    rules: { required: "State is Required!" }
  },
  mailingZip: {
    label: "Zip",
    perKey: "MailingZip",
    rules: { required: "Zip is Required!" }
  },
  mailingEmail: {
    label: "Email",
    perKey: "MailingEmail"
  },
  billingAddress1: {
    label: "Address1",
    perKey: "BillingAddress1",
    rules: { required: "Address1 is Required!" }
  },
  billingAddress2: {
    label: "Address2",
    perKey: "BillingAddress2",
  },
  billingCity: {
    label: "City",
    perKey: "BillingCity",
    rules: { required: "City is Required!" }
  },
  billingState: {
    label: "State",
    perKey: "BillingState",
    rules: { required: "State is Required!" }
  },
  billingZip: {
    label: "Zip",
    perKey: "BillingZip",
    rules: { required: "Zip is Required!" }
  },
  billingEmail: {
    label: "Email",
    perKey: "BillingEmail"
  },
  copyMailingAddress: {
    label: "Billing Address Same As Mailing Address",
    type: "checkbox"
  },
  clientSourceTypeId: {
    label: "Source",
    perKey: "ClientSourceTypeId"
  },
  clientSubSourceTypeId: {
    label: "Sub Source",
    perKey: "ClientSubSourceTypeId"
  },
  otherSubSource: {
    label: "Sub Source",
    perKey: "ClientOtherSubSource"
  }
};

export const partnerContactFormConfing = {
  contactTypeId: {
    label: "Contact Type",
    perKey: "ContactType",
    rules: { required: "Contact Type is Required!" }
  },
  firstName: {
    label: "First Name",
    perKey: "FirstName",
    rules: { required: "First Name is Required!" }
  },
  middleName: {
    label: "Middle Name",
    perKey: "MiddleName"
  },
  lastName: {
    label: "Last Name",
    perKey: "LastName",
    rules: { required: "Last Name is Required!" }
  },
  email: {
    label: "Email",
    perKey: "Email",
    rules: { required: "Email is Required!" }
  },
  cellphone: {
    label: "Cell Phone",
    perKey: "CellPhone",
    rules: {
      required: "Cell Phone is Required!"
    }
  },
  officeNumber: {
    label: "Office Number",
    perKey: "OfficeNumber",
    rules: {
      required: "Office Number is Required!"
    }
  },
  jobTitle: {
    label: "Job Title",
    perKey: "JobTitle",
    rules: { required: "Job Title is Required!" }
  },
  clientContactSourceTypeId: {
    label: "Source",
    perKey: "ClientContactSourceTypeId"
  },
  clientContactSubSourceTypeId: {
    label: "Sub Source",
    perKey: "ClientContactSubSourceTypeId"
  },
  otherSubSource: {
    label: "Sub Source",
    perKey: "ClientContactOtherSubSource"
  }
};

export const partnerDocumentFormConfing = {
  documentName: {
    label: "Document Name",
    perKey: "DocumentName",
    rules: {
      required: "Document Name is required!",
      maxLength: {
        value: 250,
        message: "Document Name cannot exceed 250 characters"
      }
    }
  },
  clientDocumentTypeId: {
    label: "Document Type",
    perKey: "SelectDocument",
    rules: { required: "Document Type is required!" }
  },
  documentFile: {
    label: "Document",
    perKey: "DocumentFileName",
    readKey: "documentFilePath",
    rules: { required: "Document is required!" }
  }
};

export const PartnersNotesFormConfing = {
  noteTypeId: {
    label: "Note Type",
    perKey: "SelectNoteType",
    rules: { required: "Note Type is required!" }
  },
  notes: {
    label: "Notes",
    perKey: "Note",
    rules: { required: "Notes is required!" },
    size: 12,
    fieldProps: { multiline: true, rows: 5 }
  },
  isPrivate: {
    label: "Is Private",
    perKey: "IsPrivate"
  }
};

export const PartnerLocationFormConfing = {
  locationName: {
    label: "Location Name",
    perKey: "Title"
  },
  email: {
    label: "Email",
    perKey: "Email"
  },
  address1: {
    label: "Address 1",
    perKey: "Address1"
  },
  address2: {
    label: "Address 2",
    perKey: "Address2"
  },
  contactNumber: {
    label: "Contact Number",
    perKey: "ContactNumber"
  },
  city: {
    label: "City",
    perKey: "City"
  },
  state: {
    label: "State",
    perKey: "State"
  },
  zip: {
    label: "Zip",
    perKey: "Zip",
    rules: {
      required: "Zip is required!"
    }
  }
};

export const PartnerSocialMediaFormConfing = {
  socialMediaType: {
    label: "Social Media Type",
    perKey: "SocialMedia"
  },
  link: {
    label: "Link",
    perKey: "Link"
  }
};
